import { AlertCircle, Check } from 'lucide-react'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/hooks/useTranslation'
import type { BpmnSaveStatus as BpmnSaveStatusType } from './hooks/useBpmnAutosave'

interface BpmnSaveStatusProps {
	status: BpmnSaveStatusType
	className?: string
}

export function BpmnSaveStatus({ status, className = '' }: BpmnSaveStatusProps) {
	const { t } = useTranslation()

	if (status === 'idle') return null

	const getStatusDisplay = () => {
		switch (status) {
			case 'dirty':
				return {
					icon: <Spinner className="w-3.5 h-3.5" />,
					label: t('pages.analysisDetail.textualSummaryEditor.saveStatus.unsaved'),
				}
			case 'saving':
				return {
					icon: <Spinner className="w-3.5 h-3.5" />,
					label: t('pages.analysisDetail.textualSummaryEditor.saveStatus.saving'),
				}
			case 'saved':
				return {
					icon: <Check className="w-3.5 h-3.5 text-green-600" />,
					label: t('pages.analysisDetail.textualSummaryEditor.saveStatus.saved'),
				}
			case 'error':
				return {
					icon: <AlertCircle className="w-3.5 h-3.5 text-red-600" />,
					label: t('pages.analysisDetail.textualSummaryEditor.saveStatus.error'),
				}
			default:
				return null
		}
	}

	const display = getStatusDisplay()
	if (!display) return null

	return (
		<div className={`flex items-center gap-2 ${className}`}>
			{display.icon}
			<span className="text-xs font-medium text-gray-700 whitespace-nowrap">{display.label}</span>
		</div>
	)
}
